import cx from 'classnames';
import * as React from 'react';

import './styles/Coin.scss';

/**
 * ## A `Coin` is a circle with centered content.
 * ### Used most often in conjunction with [Glyph](/internal/components/Glyph)s to render a circle encapsulating a centered icon.
 *
 * ```example
 * <div>
 *   <Coin color="brand" size="xxxlarge">
 *     <Glyph color="white" name="check" />
 *   </Coin>
 *   <Coin color="lava" size="xlarge">
 *     <Glyph color="white" name="check" />
 *   </Coin>
 *   <Coin border="jungle" size="medium">
 *     <Glyph color="jungle" name="check" />
 *   </Coin>
 *   <Coin border="lava" size="xxxsmall">
 *     <Glyph color="lava" name="check" />
 *   </Coin>
 * </div>
 * ```
 *
 *
 * # TODO
 * * Consider reducing `size`s
 * * Improve centering with flexbox
 * * Consider using `currentColor` to match `border-color` & `color` as default
 */

export type CoinColor =
  | 'lava'
  | 'flame'
  | 'sunrise'
  | 'jungle'
  | 'shamrock'
  | 'midnight'
  | 'brand'
  | 'violet'
  | 'pitch'
  | 'thunder'
  | 'eclipse'
  | 'koala'
  | 'white'
  | 'facebook'
  | 'pinterest'
  | 'twitter';

export type CoinSize =
  | 'inherit'
  | 'xxxlarge'
  | 'xxlarge'
  | 'xlarge'
  | 'large'
  | 'medium'
  | 'small'
  | 'xsmall'
  | 'xxsmall'
  | 'xxxsmall';

type Props = {
  children?: any;
  className?: string;
  color?: CoinColor;
  border?: CoinColor;
  size?: CoinSize;
};

class Coin extends React.Component<Props> {
  render() {
    const { children, className, border, color, size } = this.props;

    return (
      <span
        className={cx(
          'Coin',
          border && `Coin--border-${border}`,
          color && `Coin--color-${color}`,
          size && `Coin--size-${size}`,
          className
        )}>
        <span className="Coin-content">{children}</span>
      </span>
    );
  }
}

export default Coin;
